<h2 mat-dialog-title>Iniciar presolicitud de emisión</h2>
<mat-dialog-content>
  <p>Introduzca los datos de la cotización a importar</p>
  <form class="form-horizontal" [formGroup]="form">
    <mat-form-field class="full-width-field">
      <mat-label>Compañía</mat-label>
      <mat-select formControlName="insurer">
        <mat-option *ngFor="let insurer of insurers" [value]="insurer.code">{{insurer.description}}</mat-option>
      </mat-select>
      <mat-error *ngIf="form.controls['insurer'].hasError('required')">Requerido</mat-error>
    </mat-form-field>
    <mat-form-field class="full-width-field">
      <mat-label>Código cotización</mat-label>
      <input matInput formControlName="quotationID">
      <mat-error *ngIf="form.controls['quotationID'].hasError('required')">Requerido</mat-error>
    </mat-form-field>
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="onNoClick()">Cancelar</button>
  <button mat-button (click)="createClick()">Enviar</button>
</mat-dialog-actions>
